import { useMemo } from 'react';
export var setRef = function setRef(ref, value) {
  if (typeof ref === 'function') {
    ref(value);
  } else if (ref) {
    // eslint-disable-next-line no-param-reassign
    ref.current = value;
  }
};
export var forkRef = function forkRef(refs) {
  if (!refs.length) {
    return null;
  }
  return function (refValue) {
    refs.forEach(function (ref) {
      setRef(ref, refValue);
    });
  };
};
export var useForkRef = function useForkRef(refs) {
  return useMemo(function () {
    return forkRef(refs);
  }, [refs]);
};